import { Injectable } from '@angular/core';
import { WmHttpService, ProjectService } from '@wms/services';
import { environment } from '@wms/app';

@Injectable({
  providedIn: 'root',
})
export class ImportApiService {
  TARGET = 'import-api';
  locale: any;
  API_META = {
    settingsUpload: {
      url:
        environment.SERVICES_BASE_PATH +
        'services/projects/:projectID/restservice/generateSwagger',
      method: 'POST',
    },
    importRest: {
      url:
        environment.SERVICES_BASE_PATH +
        'services/projects/:projectID/restservice',
      method: 'POST',
    },
    listServices: {
      url:
        environment.SERVICES_BASE_PATH +
        'services/projects/:projectID/services',
      method: 'GET',
    },
    deleteService: {
      url:
        environment.SERVICES_BASE_PATH +
        'services/projects/:projectID/services/:serviceID',
      method: 'GET',
    },
  };
  constructor(
    private wmHttpService: WmHttpService,
    private projectService: ProjectService
  ) {
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }
  importRest(data: any) {
    return this.wmHttpService.execute({
      target: this.TARGET,
      action: 'importRest',
      pathParams: {
        projectID: this.projectService.getProjectId(),
      },
      data: data,
    }) as Promise<any>;
  }
}
